import * as React from 'react';
import { useState } from 'react';

interface FormProps {
  onSearch: (searchTerm: string) => void;
  value: string
}

const Form: React.FC<FormProps> = (props) => {

    const [searchTerm, setSearchTerm] = useState<string>(props.value === "initial_search" ? "" : props.value);
    
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        props.onSearch(searchTerm);
    };

    return (
        <form onSubmit={(e) => handleSubmit(e)} className=" py-10 px-4 laptop:px-7 desktop:py-[60px] desktop:px-[80px] bg-brown-50 rounded-lg mb-5 laptop:mb-10 ">
            <fieldset className="flex gap-2 relative">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="absolute top-3.5 left-6">
                    <path d="M21 21L16.7 16.7M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="#555555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <label htmlFor="search" className="sr-only">Søk</label>
                <input onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm === "initial_search" ? "" : searchTerm} type="search" id="search" placeholder="Søk" name="q" className="w-full  py-3 pl-[60px] pr-6 text-lg bg-white border-2 border-brown-primary rounded-xl placeholder-black-text text-black-text"/>
                <button type="submit" className="btn-primary items-center">
                    <span>Søk</span>
                </button>
            </fieldset>
        </form>
    );
};

export default Form;